import styled from 'styled-components';

export const StyledDoctorsFilter = styled.div`
   width: 300px;
`;
StyledDoctorsFilter.displayName = 'StyledDoctorsFilter';
